import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SERVER_BASE_URL } from '../environment.token';

@Component({
  selector: 'ca-banner',
  imports: [CommonModule],
  template: `
    @if (data) {
      <figure
        [style.background-image]="
          data.image && data.image.src ? 'url(' + base + data.image.src + ')' : undefined
        "
        [class]="'banner ' + (data.typeClass ?? '')"
        >
        @if (data.title) {
          <h1 class="banner-title">
            <mark>{{ data.title }}</mark>
          </h1>
        }
        @if (data.richText) {
          <div class="banner-text" [innerHTML]="data.richText"></div>
        }
        @if (data.copyright) {
          <figcaption [innerHTML]="data.copyright"></figcaption>
        }
      </figure>
    }
  `,
})
export class BannerComponent {
  @Input() data?: BannerBlockData;
  readonly base = inject(SERVER_BASE_URL);
}

export interface BannerBlockData {
  cssClass: null | string;
  title?: string;
  richText?: string;
  typeClass?: string;
  copyright?: string;
  image?: {
    src: string;
    alt: string;
  };
}
